import { isNumberInventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { getDifferencesBetweenConfigsReturn } from ".";

export function RenderNumberChange(change: getDifferencesBetweenConfigsReturn) {
  if (
    isNumberInventoryListingConfig(change.oldValue) &&
    isNumberInventoryListingConfig(change.newValue)
  ) {
    return (
      <li>
        <b>{change.config}</b> changed from <b>"{change.oldValue}"</b> to{" "}
        <b>"{change.newValue}"</b>
      </li>
    );
  }
  return null;
}
